import {ITCIValidationResult, TCIActionValidationResult} from "./tci-validation";
import {ITCIFileMap} from "./tci-util";
import {ITCIApplicationRequest, ITCIApplicationResponse, ITCITenantServiceProvider} from "./tci-tenant";
import {Observable} from "rxjs";

export enum TCI_CREATE_APP_UI_TYPE {
    DEFAULT_UI,
    FILE_UPLOAD,
    API_CHOOSER,
    EXTERNAL_URL
}

export interface ITCIApplicationCreateOption {
    valueOf(): number;

    equals(that: any): boolean;

    toString(): string;
}

/**
 *
 */
export class ApplicationCreateValidationResult extends TCIActionValidationResult implements ITCIApplicationCreateResponse {
    /**
     * Application Id
     */
    appId: string;
    /**
     * Application Name
     */
    name: string;
    /**
     * Application Response status
     */
    success: boolean;
    /**
     * Application Response message
     */
    msg?: string;
    /**
     * ApplicationCreation data to be returned
     */
    result?: any | ITCIFileMap;

}

/**
 * interface ITCIApplicationCreateRequest
 */
export interface ITCIApplicationCreateRequest extends ITCIApplicationRequest {
    /**
     * Application create input key - Swagger Specification id
     */
    appInputId?: number;
    /**
     * Application naming prefix
     */
    appNamePrefix?: string;
    /**
     * Generated Application Name
     */
    name?: string;
    /**
     *  Application create option
     */
    create_option: ITCIApplicationCreateOption;
    /**
     *  App Creation Data to be uploaded
     */
    appData?: ITCIFileMap | Uint8Array | any;
}

/**
 * interface ITCIApplicationCreateResponse
 */
export interface ITCIApplicationCreateResponse extends ITCIApplicationResponse {
    /**
     * name
     */
    name: string; // Mandatory for "Create"

    /**
     * Warnings that may emerge during application creation.
     * If there are elements then the warnings list would be displayed.
     */
    warnings?: TCIActionValidationResult;
}


/**
 * interface Application Create Provider
 */
export interface ITCIApplicationCreateProvider extends ITCITenantServiceProvider {
    /**
     * Check before calling importApplication
     * @param input
     */
    canCreate(input: ITCIApplicationCreateRequest): Observable<boolean | ITCIValidationResult>;

    /**
     * Validate before importing if there are dependency errors
     * The validation result can be an error or warning
     * @param input
     */
    validate(input: ITCIApplicationCreateRequest): Observable<ITCIValidationResult>;

    /**
     * import application
     * @param input
     * @param returnUrl
     */
    createApplication(input: ITCIApplicationCreateRequest, returnUrl?: string): Observable<ITCIApplicationCreateResponse>;

    /**
     * Determines if the tenant is providing an External wizard.
     */
    isExternalWizard(): Observable<boolean>;

    /**
     * Get the external wizard URL from tenant
     * @param input
     */
    getExternalWizardUrl(input: ITCIApplicationCreateRequest): Observable<string>;
}

/**
 * Check if the canCreate(): Observable<boolean|ITCIValidationResult>
 * @param result
 */
export function isITCIValidationResult(result: any): result is ITCIValidationResult {
    return "type" in result
        && "state" in result
        && "errors" in result
        && (<ITCIValidationResult>result).getType !== undefined
        && (<ITCIValidationResult>result).getErrors !== undefined
        && (<ITCIValidationResult>result).setError !== undefined;
}
